<template>
  <div class="content">
    <!-- 新增按钮 -->
    <!-- <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-button type="primary" @click="kaihuBtn">新增</el-button>
      </el-form-item>
    </el-form> -->
    <!-- 商品表格 -->
    <el-table
      :data="beforArr"
      style="width: 100%;overflow-y: scroll;"
      height="calc(100vh - 220px)"
      v-loading="loading"
      border
      :header-cell-style="{
        background: '#e8effc',
        color: '#000',
        borderColor: 'white',
      }"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="图片" width="100" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.url" alt style="width:100%" />
          </template>
        </el-table-column> -->
      <!-- <el-table-column label="客户ID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.userId ? scope.row.userId : "暂无" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="客户姓名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name ? scope.row.name : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户手机号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.phone ? scope.row.phone : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户留言" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.odescribe ? scope.row.odescribe : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户邮箱" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.email ? scope.row.email : "暂无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="提交时间" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="130" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="deleteAdmin(scope.row)"
            :disabled="$store.state.supUser.roleId == 1"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增表单 -->
    <el-dialog
      :title="inputTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="标记">
          <el-input v-model="form.msg" auto-complete="off" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="排序">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item> -->
      </el-form>
      <!-- <el-upload
        class="upload-demo"
        :action="action"
        :multiple="false"
        :on-success="handleSuccess_cover"
        :file-list="fileList"
        list-type="picture"
        name="formData"
        :limit="1"
      >
        <el-button size="small" type="primary">点击上传图片(1张)</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传jpg/png文件，750px X 300px
        </div>
      </el-upload> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbmitBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectFankui, deleteFankui } from "@/services/niaojian/fankui.js";
import { IP } from "@/services/index.js";
export default {
  data() {
    return {
      beforArr: [],
      inputTitle: "新增",
      cover: "",
      fileList: [],
      action: IP + "/uploadFile/add",
      loading: true,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: "0" },
        { name: "普通子账号权限", id: "1" },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {

    this.selectData();
  },
  methods: {
    // 查询
    selectData() {
      selectFankui().then((resp) => {

        this.loading = false;
        this.beforArr = resp.data;
        // this.$message({
        //   type: "success",
        //   message: "跟新成功!"
        // });
        // this.pageCount = resp.pageCount;
      });
    },
    // 新增按钮
    kaihuBtn() {
      this.inputTitle = "新增";
      this.dialogFormVisible = true;
      this.form = {};
      this.fileList = [];
    },
    ejectupdateGoods(row) {
      
      this.dialogFormVisible = true;
      this.inputTitle = "处理";
      this.form = JSON.parse(JSON.stringify(row));
      this.fileList = [];
    },
    handleSuccess_cover(e) {
  
      this.form.url = e.data;
      console.log(this.form);
    },
    // 表单提交按钮
    sumbmitBtn() {
      console.log(this.form);
    },
    // 删除
    deleteAdmin(row) {
      this.$confirm("此操作将永久删除该账号, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteFankui(row.id).then((resp) => {
    
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectData();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style>
.content {
  margin: 10px auto;
  width: 98%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
